import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/src/components/Docs/DocsLayout.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Feature Flag`}</h1>
    <h2>{`Check feature`}</h2>
    <p>{`Check if a feature is enabled for the specified userId when the engine was instantiated.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-kt"
      }}>{`val featureId = "feature-1"

tesfyEngine.isFeatureEnabled(featureId, null) // true
`}</code></pre>
    <p>{`You could also specify a `}<inlineCode parentName="p">{`userId`}</inlineCode>{` and `}<inlineCode parentName="p">{`attributes`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-kt"
      }}>{`val userId = "676380e0-7793-44d6-9189-eb5868e17a86"
val attributes = mapOf("countryCode" to "us")
val featureId = "feature-1"

tesfyEngine.isFeatureEnabled(featureId, userId, attributes) // true
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      